export const QUICK_LINK_LIST = {
  en: [
    {
      route: 'drivers',
      featureName: 'Add Driver',
      breadcrumb: 'Drivers / Add Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Coaching',
      breadcrumb: 'Coaching Events',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Fleet Safety Report',
      breadcrumb: 'Reports / Fleet Safety Report',
    },
  ],
  es: [
    {
      route: 'drivers',
      featureName: 'Agregar conductor',
      breadcrumb: 'Controladores / Agregar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Capacitación',
      breadcrumb: 'Eventos de Capacitación',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Informe de seguridad de la flota',
      breadcrumb: 'Informes / Informe de seguridad de la flota',
    },
  ],
  fr: [
    {
      route: 'drivers',
      featureName: 'Ajouter un pilote',
      breadcrumb: 'Pilotes / Ajouter un pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Encadrement',
      breadcrumb: "Événements d'entraînement",
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Rapport sur la sécurité de la flotte',
      breadcrumb: 'Rapports / Rapport sur la sécurité de la flotte',
    },
  ],
  pt: [
    {
      route: 'drivers',
      featureName: 'Adicionar motorista',
      breadcrumb: 'Drivers / Adicionar driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Treinamento',
      breadcrumb: 'Eventos de coaching',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Relatório de Segurança da Frota',
      breadcrumb: 'Relatórios / Relatório de Segurança da Frota',
    },
  ],
  'pt-BR': [
    {
      route: 'drivers',
      featureName: 'Adicionar motorista',
      breadcrumb: 'Motoristas  / Adicionar motorista',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Treinamento',
      breadcrumb: 'Eventos de treinamento',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Relatório de segurança da frota',
      breadcrumb: 'Relatórios / Relatório de segurança da frota',
    },
  ],
  'fr-CA': [
    {
      route: 'drivers',
      featureName: 'Pilote',
      breadcrumb: 'Pilotes / Ajouter Un Conducteur',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'coaching',
      breadcrumb: 'Conducteurs Entraînables',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Rapport sur la sécurité de la flotte',
      breadcrumb: 'Rapports / Rapport sur la sécurité de la flotte',
    },
  ],
  'en-GB': [
    {
      route: 'drivers',
      featureName: 'Add Driver',
      breadcrumb: 'Drivers / Add Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'Coaching',
      breadcrumb: 'Coaching Events',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Fleet Safety Report',
      breadcrumb: 'Reports / Fleet Safety Report',
    },
  ],
  'es-419': [
    {
      route: 'drivers',
      featureName: 'Agregar controlador',
      breadcrumb: 'Controladores / Agregar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'coaching',
      breadcrumb: 'コーチング・イベント',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Informe de seguridad de la flota',
      breadcrumb: 'Informes / Informe de Seguridad de la Flota',
    },
  ],
  ja: [
    {
      route: 'drivers',
      featureName: 'ドライバーの追加r',
      breadcrumb: 'ドライバー / ドライバーの追加',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: 'コーチング',
      breadcrumb: 'コーチング・イベント',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: '車両安全レポート',
      breadcrumb: 'レポート / 車両安全レポート',
    },
  ],
  ko: [
    {
      route: 'drivers',
      featureName: '운전자 추가',
      breadcrumb: '운전자 / 운전자 추가',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'coaching',
      featureName: '코칭',
      breadcrumb: '코칭 이벤트',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'reports/fleet-safety',
      featureName: '차량 안전 보고서',
      breadcrumb: '보고서 / 차량 안전 보고서',
    },
  ],
};

export const SEARCH_AUTOCOMPLETE_LIST = {
  en: [
    // home
    {
      route: 'home',
      featureName: 'Fleet Highlights',
      breadcrumb: 'Home / Fleet Highlights',
    },
    {
      route: 'home',
      featureName: 'Top Drivers',
      breadcrumb: 'Home / Top Drivers',
      featureFlag: 'home:top_drivers',
    },
    {
      route: 'home',
      featureName: 'Require Coaching Drivers',
      breadcrumb: 'Home / Require Coaching Drivers',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: 'Event Summary',
      breadcrumb: 'Home / Event Summary',
    },
    {
      route: 'home',
      featureName: 'Event Trend',
      breadcrumb: 'Home / Event Trend',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Trip List',
      breadcrumb: 'Trips / Overview / Trip List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Active Drivers',
      breadcrumb: 'Trips / Overview / Active Drivers',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Add Driver',
      breadcrumb: 'Drivers / Add Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Highlights',
      breadcrumb: 'Drivers / Overview / Driver Highlights',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Coach Driver',
      breadcrumb: 'Drivers / Overview / Coach Driver',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Driver Assign Tags',
      breadcrumb: 'Drivers / Overview / Assign Tags',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Driver Coaching Panel',
      breadcrumb: 'Drivers / Overview / Coaching Panel',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Driver Panic Button',
      breadcrumb: 'Drivers / Overview / Panic Button',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Event Summary',
      breadcrumb: 'Drivers / Overview / Event Summary',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Event Trend',
      breadcrumb: 'Drivers / Overview / Event Trend',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver List',
      breadcrumb: 'Drivers / Manage Drivers / Driver List',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Provision Driver',
      breadcrumb: 'Drivers / Manage Drivers / Provision Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Coaching Session',
      breadcrumb: 'Drivers / Overview / Coach Driver',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Completed Sessions',
      breadcrumb: 'Drivers / Overview / Completed Sessions',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Live Asset Tracking',
      breadcrumb: 'Live View / Live Asset Tracking',
    },
    {
      route: 'live-view',
      featureName: 'View Live Stream',
      breadcrumb: 'Live View / View Live Stream',
    },
    // report
    {
      route: 'reports',
      featureName: 'Reports',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Fleet Safety Report',
      breadcrumb: 'Reports / Fleet Safety Report',
    },
    {
      route: 'reports',
      featureName: 'Export History',
      breadcrumb: 'Reports / Export history',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Privacy Mode Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Video Request List Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Event Count Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Event List Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'High-G Event List Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Panic Button List Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Coaching Effectiveness Report (Driver)',
      breadcrumb: 'Reports / Coaching Effectiveness Report (Driver)',
      featureFlag: 'reports:coaching_effectiveness_report',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Asset List',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Driver Assignment',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Modify Asset Duty Type',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Format Device SD Card',
      breadcrumb: 'Assets / Overview / Asset List ',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Reboot Device',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Batch Asset Update',
      breadcrumb: 'Assets / Manage / Batch Updation',
      queryParams: {
        tab: 'manage',
      },
    },
    {
      route: 'assets',
      featureName: 'Devices',
      breadcrumb: 'Assets / Devices / Semi-Provisioned Devices',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Semi-Provisioned Devices',
      breadcrumb: 'Assets / Devices / Semi-Provisioned Devices',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Basic Configurations',
      breadcrumb: 'Configurations / Basic / Basic Configurations',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Custom Events',
      breadcrumb: 'Configurations / Basic / Custom Events',
      queryParams: {
        tab: 'basic',
      },
      featureFlag: 'custom_events',
    },
    {
      route: 'configurations',
      featureName: 'Advanced Configurations',
      breadcrumb: 'Configurations / Advanced / Advanced Configurations',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Coaching Thresholds',
      breadcrumb: 'Configurations / Coaching / Coaching Thresholds',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Coaching Config',
      breadcrumb: 'Configurations / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Tagging',
      breadcrumb: 'Configurations / Tagging',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Attributes',
      breadcrumb: 'Configurations / Tagging / Attributes',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Add Attributes',
      breadcrumb: 'Configurations / Tagging / Add Attribute',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Tags',
      breadcrumb: 'Configurations / Tagging / Tags',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Add Tags',
      breadcrumb: 'Configurations / Tagging / Add Tags',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Entities',
      breadcrumb: 'Configurations / Tagging / Entities',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Challenged Events',
      breadcrumb: 'Challenges / Challenged Events',
      featureFlag: 'challenges_page',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Coaching Panel',
      breadcrumb: 'Coaching / Coaching Panel',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Coachable Drivers',
      breadcrumb: 'Coaching / Coachable Drivers',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Completed Coaching Sessions',
      breadcrumb: 'Coaching / Completed Coaching Sessions',
      featureFlag: 'coaching_workflow',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Events',
      breadcrumb: 'Safety Events / Events View',
    },
    {
      route: 'safety-events',
      featureName: 'Safety Events',
      breadcrumb: 'Safety Events / Events View',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Video Request',
      breadcrumb: 'Video Request',
    },
    {
      route: 'video-requests',
      featureName: 'Video Requests List',
      breadcrumb: 'Video Requests List',
    },
    {
      route: 'video-requests',
      featureName: 'Panic Button List',
      breadcrumb: 'Panic Button List',
    },
    {
      route: 'video-requests',
      featureName: 'Event On-Demand List',
      breadcrumb: 'Event On-Demand List',
    },
    {
      route: 'video-requests',
      featureName: 'Create Video Requests',
      breadcrumb: 'Create Video Request',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Users',
      breadcrumb: 'Users',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management/edit-user',
      featureName: 'Add Users',
      breadcrumb: 'Users / Add User',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Roles',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management/edit-role',
      featureName: 'ADD Roles',
      breadcrumb: 'Roles / Add Role',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],
  es: [
    // home
    {
      route: 'home',
      featureName: 'Aspectos destacados de la flota',
      breadcrumb: 'Inicio / Lo más destacado de la flota',
    },
    {
      route: 'home',
      featureName: 'Conductores mejores',
      breadcrumb: 'Inicio / Principales conductores',
      featureFlag: 'home:top_drivers',
    },
    {
      route: 'home',
      featureName: 'Requiere entrenadoras',
      breadcrumb: 'Inicio / Requiere entrenadoras',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: 'Resumen de eventos',
      breadcrumb: 'Inicio / Resumen del eventos',
    },
    {
      route: 'home',
      featureName: 'Tendencia de eventoss',
      breadcrumb: 'Inicio / Tendencia de eventoss',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Lista de viajes',
      breadcrumb: 'Viajes / Descripción general / Lista de viajes',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Conductores activos',
      breadcrumb: 'Viajes / Descripción general / Conductores activos',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Agregar conductor',
      breadcrumb: 'Controladores / Agregar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Aspectos destacados del conductor',
      breadcrumb: 'Controladores / Descripción general / Aspectos destacados del controlador',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Panel de entrenamiento de conductores',
      breadcrumb: 'Controladores / Descripción general / Panel de entrenamiento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Botón de pánico del conductor',
      breadcrumb: 'Controladores / Descripción general / Botón de pánico',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Resumen del evento del conductor',
      breadcrumb: 'Controladores / Descripción general / Resumen de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendencia de eventos del conductor',
      breadcrumb: 'Impulsores / Descripción general / Tendencia de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Lista de conductores',
      breadcrumb: 'Controladores / Administrar controladores / Lista de controladores',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Conductora de provisión',
      breadcrumb: 'Controladores / Administrar controladores / Aprovisionar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sesión de coaching',
      breadcrumb: 'Conductores / Visión general / Conductor de autocar',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Sesiones finalizadas',
      breadcrumb: 'Conductores / Visión general / Sesiones finalizadas',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },

    {
      route: 'drivers',
      featureName: 'Conductor de autocar',
      breadcrumb: 'Conductores / Visión general / Conductor de autocar',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Etiquetas de asignación de conductores',
      breadcrumb: 'Controladores / Visión general / Asignar etiquetas',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Seguimiento de activos en vivo',
      breadcrumb: 'Vista en vivo / Seguimiento de activos en vivo',
    },
    {
      route: 'live-view',
      featureName: 'Ver transmisión en vivo',
      breadcrumb: 'Vista en vivo / Ver transmisión en vivo',
    },
    // report
    {
      route: 'reports',
      featureName: 'Informes',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Informe de seguridad de la flota',
      breadcrumb: 'Informes / Informe de seguridad de la flota',
    },
    {
      route: 'reports',
      featureName: 'Historial de exportaciones',
      breadcrumb: 'Informes / Exportación-Historia',
      queryParams: {
        tab: 'export-history',
      },
    },

    {
      route: 'reports',
      featureName: 'Informe de modo de privacidad',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de solicitud de video',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de recuento de eventos',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de lista de eventos',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de eventos de alta G',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de lista de botones de pánico',
      breadcrumb: 'Informes / Todos los informes',
    },

    {
      route: 'reports',
      featureName: 'Informe sobre la eficacia del entrenamiento (Conductor)',
      breadcrumb: 'Informes / Informe sobre la eficacia del entrenamiento (Conductor)',
      featureFlag: 'reports:coaching_effectiveness_report',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Lista de activos',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Asignación de conductor',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Modificar tipo de derecho de activo',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Formatear la tarjeta SD del dispositivo',
      breadcrumb: 'Activos / Lista de activos ',
    },
    {
      route: 'assets',
      featureName: 'Reiniciar dispositivo',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Dispositivos',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos semiprovisionados',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configuraciones básicas',
      breadcrumb: 'Configuraciones / Básica / Configuraciones Básicas',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Eventos personalizados',
      breadcrumb: 'Configuraciones / Básica / Eventos personalizados',
      queryParams: {
        tab: 'basic',
      },
      featureFlag: 'custom_events',
    },
    {
      route: 'configurations',
      featureName: 'Configuraciones avanzadas',
      breadcrumb: 'Configuraciones / Avanzadas / Configuraciones Avanzadas',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Umbrales de entrenamiento',
      breadcrumb: 'Configuraciones / Coaching / Umbrales de entrenamiento',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Configuración de Coaching',
      breadcrumb: 'Configuraciones / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Etiquetado',
      breadcrumb: 'Configuraciones / Etiquetado',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Atributos',
      breadcrumb: 'Configuraciones / Etiquetado / Atributos',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Añadir atributos',
      breadcrumb: 'Configuraciones / Etiquetado / Añadir atributo',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Etiquetas',
      breadcrumb: 'Configuraciones / Etiquetado / Etiquetas',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Añadir etiquetas',
      breadcrumb: 'Configuraciones / Etiquetado / Añadir etiquetas',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Entidades',
      breadcrumb: 'Configuraciones / Etiquetado / Entidades',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Eventos cuestionados',
      breadcrumb: 'Cuestionados / Eventos cuestionados',
      featureFlag: 'challenges_page',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Panel de entrenamiento',
      breadcrumb: 'Panel de Entrenamiento / Coaching',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Conductores entrenables',
      breadcrumb: 'Coaching / Conductores entrenables',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Sesiones de coaching completadas',
      breadcrumb: 'Coaching / Sesiones de coaching completadas',
      featureFlag: 'coaching_workflow',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Eventos',
      breadcrumb: 'Eventos de seguridad / Vista de eventos',
    },
    {
      route: 'safety-events',
      featureName: 'Eventos de seguridad',
      breadcrumb: 'Eventos de seguridad / Vista de eventos',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Solicitudes de vídeo',
      breadcrumb: 'Solicitudes de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de solicitudes de vídeo',
      breadcrumb: 'Lista de solicitudes de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de botones de pánico',
      breadcrumb: 'Lista de botones de pánico',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de eventos a la carta',
      breadcrumb: 'Lista de eventos a la carta',
    },
    {
      route: 'video-requests',
      featureName: 'Crear solicitud de vídeo',
      breadcrumb: 'Crear solicitud de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'USUARIOS',
      breadcrumb: 'USUARIOS',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'AÑADIR USUARIO',
      breadcrumb: 'USUARIOS',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Roles',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management',
      featureName: 'AÑADIR ROL',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],
  fr: [
    // home
    {
      route: 'home',
      featureName: 'Faits saillants de la flotte',
      breadcrumb: 'Accueil / Faits saillants de la flotte',
    },
    {
      route: 'home',
      featureName: 'Meilleurs chauffeurss',
      breadcrumb: 'Accueil / Meilleurs pilotes',
    },
    {
      route: 'home',
      featureName: 'Exiger des chauffeurs entraîneurs',
      breadcrumb: 'Accueil / Exiger des chauffeurs entraîneurs',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: 'Résumé des Événements',
      breadcrumb: "Accueil / Résumé de l'Événement",
    },
    {
      route: 'home',
      featureName: 'Tendance des Événements',
      breadcrumb: 'Accueil / Tendance des Événements',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Liste de voyage',
      breadcrumb: 'Trajets / Aperçu / Liste des trajets',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Conducteurs actifs',
      breadcrumb: 'Trajets / Aperçu / Conducteurs actifs',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Ajouter un pilote',
      breadcrumb: 'Pilotes / Ajouter un pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Faits saillants du chauffeur',
      breadcrumb: 'Pilotes / Aperçu / Faits saillants des pilotes',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Panneau d'encadrement des conducteurs",
      breadcrumb: 'Pilotes / Aperçu / Panel de coaching',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Bouton panique du conducteur',
      breadcrumb: 'Pilotes / Aperçu / Bouton panique',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Résumé de l'événement du conducteur",
      breadcrumb: "Pilotes / Présentation / Résumé de l'événement",
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendance des événements de conduite',
      breadcrumb: 'Pilotes / Aperçu / Tendance des événements',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Liste des pilotes',
      breadcrumb: 'Pilotes / Gérer les pilotes / Liste des pilotes',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Provisionner le pilote',
      breadcrumb: 'Pilotes / Gérer les pilotes / Provisionner le pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Session de coaching',
      breadcrumb: "'Chauffeurs / Aperçu / Chauffeur d'autocar'",
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Sessions terminées',
      breadcrumb: 'Chauffeurs / Aperçu / Sessions terminées',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: "Chauffeur d'autocar",
      breadcrumb: "Chauffeurs / Aperçu / Chauffeur d'autocar",
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: "Tags sur l'attribution des conducteurs",
      breadcrumb: 'Pilotes / Aperçu / Attribuer des étiquettes',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Suivi des actifs en direct',
      breadcrumb: 'Live View / Live Asset Tracking',
    },
    {
      route: 'live-view',
      featureName: 'Voir la diffusion en direct',
      breadcrumb: 'Affichage en direct/suivi des actifs en direct',
    },
    // report
    {
      route: 'reports',
      featureName: 'Rapports',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Rapport sur la sécurité de la flotte',
      breadcrumb: 'Rapports / Rapport sur la sécurité de la flotte',
    },
    {
      route: 'reports',
      featureName: 'Historique des exportations',
      breadcrumb: 'Rapports / Histoire des exportations',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Rapport du mode confidentialité',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport de demande de vidéo',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport de comptage des événements',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport de la liste des événements',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport des événements à forte accélération',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport de la liste des boutons de panique',
      breadcrumb: 'Rapports / Tous les rapports',
    },

    {
      route: 'reports',
      featureName: "Rapport sur l'efficacité de l'entraînement (conducteur)",
      breadcrumb: "Rapports / Rapport sur l'efficacité de l'entraînement (conducteur)",
      featureFlag: 'reports:coaching_effectiveness_report',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Liste des actifs',
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: 'Affectation du conducteur',
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Modifier le type de droit de l'actif",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Formater la carte SD de l'appareil",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Redémarrer l'appareil",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: 'Dispositifs',
      breadcrumb: 'Actifs / Appareils / Appareils semi-provisionnés',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Appareils semi-provisionnés',
      breadcrumb: 'Actifs / Appareils / Appareils semi-provisionnés',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configurations de base',
      breadcrumb: 'Configurations / De base / Configurations de base',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Événements personnalisés',
      breadcrumb: 'Configurations / De base / Événements personnalisés',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Configurations avancées',
      breadcrumb: 'Configurations / Avancées / Configurations avancées',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Seuils d entraînement',
      breadcrumb: 'Configurations / Coaching / Seuils d entraînement',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Coaching Config',
      breadcrumb: 'Configurations / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Balisage',
      breadcrumb: 'Configurations / balisage',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Attributs',
      breadcrumb: 'Configurations / balisage / attributs',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Ajouter des attributs',
      breadcrumb: 'Configurations / Balisage / Ajouter un attribut',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Balises',
      breadcrumb: 'Configurations / Balisage / Balises',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Ajouter des tags',
      breadcrumb: 'Configurations / Balisage / Ajouter des balises',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Entités',
      breadcrumb: 'Configurations / Balisage / Entités',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Événements contestés',
      breadcrumb: 'Défis / Événements contestés',
      featureFlag: 'tagging_workflow',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: "Panneau d'encadrement",
      breadcrumb: "Entraînement / Panel d'entraîneursl",
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Conducteurs entraînables',
      breadcrumb: 'Coaching / Conducteurs à coacher',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Sessions de coaching terminées',
      breadcrumb: 'Coaching / Sessions de coaching terminées',
      featureFlag: 'coaching_workflow',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Événements',
      breadcrumb: 'Événements de sécurité / Vue des Événements',
    },
    {
      route: 'safety-events',
      featureName: 'Événements liés à la sécurité',
      breadcrumb: "Événements de sécurité / Vue d'ensemble des événements",
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Demandes de vidéo',
      breadcrumb: 'Demandes de vidéo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de pedidos de vídeo',
      breadcrumb: 'Lista de pedidos de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des boutons de panique',
      breadcrumb: 'Panic Button List',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des événements à la demande',
      breadcrumb: 'Liste des événements à la demande',
    },
    {
      route: 'video-requests',
      featureName: 'Criar pedido de vídeo',
      breadcrumb: 'Criar pedido de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Utilisateurs',
      breadcrumb: 'Utilisateurs',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Ajouter un utilisateur',
      breadcrumb: 'Utilisateurs',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Rôles',
      breadcrumb: 'Rôles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management',
      featureName: 'AJOUTER RÔLE ',
      breadcrumb: 'Rôles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],
  pt: [
    // home
    {
      route: 'home',
      featureName: 'Destaques da frota',
      breadcrumb: 'Home / Destaques da Frota',
    },
    {
      route: 'home',
      featureName: 'Principais motoristas',
      breadcrumb: 'Início / Principais motoristas',
      featureFlag: 'home:top_drivers',
    },
    {
      route: 'home',
      featureName: 'Requer treinamento',
      breadcrumb: 'Início / Exigir motoristas de treinamento',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: 'Resumo do evento',
      breadcrumb: 'Início / Resumo do evento',
    },
    {
      route: 'home',
      featureName: 'Tendência de evento',
      breadcrumb: 'Início / Tendência do evento',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Lista de viagens',
      breadcrumb: 'Viagens / Visão geral / Lista de viagens',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Drivers ativos',
      breadcrumb: 'Viagens / Visão geral / Motoristas ativos',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Adicionar motorista',
      breadcrumb: 'Drivers / Adicionar driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Destaques do motorista',
      breadcrumb: 'Drivers / Visão geral / Destaques do driver',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Painel de Orientação de Motoristas',
      breadcrumb: 'Drivers / Visão geral / Painel de treinamento',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Botão de pânico do motorista',
      breadcrumb: 'Drivers / Visão geral / Botão de pânico',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Resumo do evento do motorista',
      breadcrumb: 'Drivers / Visão geral / Resumo do Evento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendência de eventos de motorista',
      breadcrumb: 'Drivers / Visão geral / Resumo do evento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Lista de motoristas',
      breadcrumb: 'Drivers / Gerenciar Drivers / Lista de Drivers',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver de provisão',
      breadcrumb: 'Drivers / Gerenciar Drivers / Provisionar Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sessão de Coaching',
      breadcrumb: 'Motoristas / Resumo / Motorista de autocarro',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Sessões concluídas',
      breadcrumb: 'Drivers / Visão geral / Sessões concluídas',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Motorista de autocarro',
      breadcrumb: 'Motoristas / Resumo / Motorista de autocarro',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Etiquetas de atribuição de condutor',
      breadcrumb: 'Condutores / Descrição geral / Atribuir etiquetas',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Rastreamento de ativos ao vivo',
      breadcrumb: 'Visualização ao vivo / Rastreamento de ativos ao vivo',
    },
    {
      route: 'live-view',
      featureName: 'Ver transmissão ao vivo',
      breadcrumb: 'Visualização ao vivo/Visualização de transmissão ao vivo',
    },
    // report
    {
      route: 'reports',
      featureName: 'Relatórios',
      breadcrumb: 'Relatórios / Todos os Relatórios',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Relatório de Segurança da Frota',
      breadcrumb: 'Relatórios / Relatório de Segurança da Frota',
    },
    {
      route: 'reports',
      featureName: 'Histórico de exportação',
      breadcrumb: 'Relatórios / História da exportação',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Relatório do modo de privacidade',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório de solicitação de vídeo',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório de contagem de eventos',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório da lista de eventos',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório de eventos de alta gravidade',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório da lista de botões de pânico',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório de Eficácia do Coaching (Driver)',
      breadcrumb: 'Relatórios / Relatório de Eficácia do Coaching (Driver)',
      featureFlag: 'reports:coaching_effectiveness_report',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Lista de ativos',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Atribuição de Motorista',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Modificar tipo de dever de ativo',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Formatar o cartão SD do dispositivo',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Reinicializar dispositivo',
      breadcrumb: 'Ativos / Lista de ativos',
    },
    {
      route: 'assets',
      featureName: 'Dispositivos',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semi-provisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos semi-provisionados',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semi-provisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configurações Básicas',
      breadcrumb: 'Configurações / Básico / Configurações Básicas',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Eventos personalizados',
      breadcrumb: 'Configurações / Básico / Eventos personalizados',
      queryParams: {
        tab: 'basic',
      },
      featureFlag: 'custom_events',
    },
    {
      route: 'configurations',
      featureName: 'Configurações avançadas',
      breadcrumb: 'Configurações / Configurações Avançadas / Avançadas',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Limiares de Coaching',
      breadcrumb: 'Configurações / Coaching / Limiares de Coaching',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Configuração de treino',
      breadcrumb: 'Configurações / Coaching / Configuração do Coaching',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Marcação',
      breadcrumb: 'Configurações / Marcação',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Atributos',
      breadcrumb: 'Configurações / Marcação / Atributos',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Adicionar atributos',
      breadcrumb: 'Configurações / Marcação / Adicionar atributo',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Etiquetas',
      breadcrumb: 'Configurações / Marcação / Etiquetas',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Adicionar etiquetas',
      breadcrumb: 'Configurações / Marcação / Adicionar etiquetas',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Entidades',
      breadcrumb: 'Configurações / Marcação / Entidades',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Evento Desafiados',
      breadcrumb: 'Desafios / Eventos Desafiados',
      featureFlag: 'challenges_page',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Painel de Treino',
      breadcrumb: 'Coaching / Painel de Coaching',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Condutores treináveis',
      breadcrumb: 'Coaching / Condutores treináveis',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Sessões de Coaching concluídas',
      breadcrumb: 'Coaching / Sessões de Coaching concluídas',
      featureFlag: 'coaching_workflow',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Eventos',
      breadcrumb: 'Eventos de segurança / Vista de Eventos',
    },
    {
      route: 'safety-events',
      featureName: 'Eventos de segurança',
      breadcrumb: 'Eventos de segurança / Eventos Ver',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Pedidos de vídeo',
      breadcrumb: 'Pedidos de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des demandes de vidéos',
      breadcrumb: 'Liste des demandes de vidéos',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de Botões de Pânico',
      breadcrumb: 'Lista de Botões de Pânico',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de eventos a pedido',
      breadcrumb: 'Lista de eventos a pedido',
    },
    {
      route: 'video-requests',
      featureName: 'Créer une demande de vidéo',
      breadcrumb: 'Créer une demande de vidéo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Utilizadores',
      breadcrumb: 'Utilizadores',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'ADICIONAR UTILIZADOR',
      breadcrumb: 'Utilizadores',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Funções',
      breadcrumb: 'Funções',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management',
      featureName: 'ADICIONAR ROLE',
      breadcrumb: 'Funções',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],
  'pt-BR': [
    // home
    {
      route: 'home',
      featureName: 'Destaques da frota',
      breadcrumb: 'Início  / Destaques da frota',
    },
    {
      route: 'home',
      featureName: 'Principais motoristas',
      breadcrumb: 'Início / Principais motoristas',
      featureFlag: 'home:top_drivers',
    },
    {
      route: 'home',
      featureName: 'Exigir condutores de treinamento',
      breadcrumb: 'Início / Exigir motoristas de treinamento',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: 'Resumo do evento',
      breadcrumb: 'Início / Resumo do evento',
    },
    {
      route: 'home',
      featureName: 'Tendência de eventos',
      breadcrumb: 'Início / Tendência de eventos',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Lista de viagens',
      breadcrumb: 'Viagens / Visão geral / Lista de viagens',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Motoristas ativos',
      breadcrumb: 'Viagens / Visão geral / Motorista ativo',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Adicionar motorista',
      breadcrumb: 'Motoristas / Adicionar motorista',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Destaques do motorista',
      breadcrumb: 'Motoristas / Visão geral / Destaques do motorista',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Motorista de ônibus',
      breadcrumb: 'Motoristas / Visão geral / Motorista de ônibus',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Tags de atribuição de motorista',
      breadcrumb: 'Motoristas / Visão geral / Atribuir tags',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Painel de treinamento de motoristas',
      breadcrumb: 'Condutores / Visão geral / Painel de treinamento',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Botão de pânico do motorista',
      breadcrumb: 'Motoristas / Visão geral / Botão de pânico',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Resumo do evento do motorista',
      breadcrumb: 'Motoristas / Visão geral / Resumo do evento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendência de eventos do motorista',
      breadcrumb: 'Motoristas / Visão geral / Tendência de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Lista de drivers',
      breadcrumb: 'Motoristas / Gerenciar motoristas / Lista de motoristas',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Motorista de provisão',
      breadcrumb: 'Motoristas / Gerenciar motoristas / Prover motorista',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sessão de treinamento',
      breadcrumb: 'Motoristas / Visão geral / Motorista de ônibus',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Sessões concluídas',
      breadcrumb: 'Motoristas / Visão geral / Sessões concluídas',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Rastreamento de ativos em tempo real',
      breadcrumb: 'Exibição ao vivo/rastreamento de ativos ao vivo',
    },
    {
      route: 'live-view',
      featureName: 'Ver transmissão ao vivo',
      breadcrumb: 'Exibição ao vivo / Exibir transmissão ao vivo',
    },
    // report
    {
      route: 'reports',
      featureName: 'Relatórios',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Relatório de segurança da frota',
      breadcrumb: 'Relatórios / Relatório de segurança da frota',
    },
    {
      route: 'reports',
      featureName: 'Histórico de exportação',
      breadcrumb: 'Relatórios / História da exportação',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Relatório do modo de privacidade',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório de solicitação de vídeo',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório de contagem de eventos',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório da lista de eventos',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório de eventos com alta força G',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },
    {
      route: 'reports',
      featureName: 'Relatório da lista de botões de pânico',
      breadcrumb: 'Relatórios / Todos os relatórios',
    },

    {
      route: 'reports',
      featureName: 'Relatório de Eficácia do Coaching (Driver)',
      breadcrumb: 'Relatórios / Relatório de Eficácia do Coaching (Driver)',
      featureFlag: 'reports:coaching_effectiveness_report',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Lista de ativos',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Atribuição de motorista',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Modificar o tipo de dever do ativo',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Formatar o cartão SD do dispositivo',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Reinicialização do dispositivo',
      breadcrumb: 'Ativos / Visão geral / Lista de ativos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Atualização de ativos em lote',
      breadcrumb: 'Ativos / Gerenciar / Atualização de lotes',
      queryParams: {
        tab: 'manage',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos',
      breadcrumb: 'Ativos / Dispositivos / Dispositivos semi-provisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos semiprovisionados',
      breadcrumb: 'Ativos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configurações básicas',
      breadcrumb: 'Configurações / Básico / Configurações básicas',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Eventos personalizados',
      breadcrumb: 'Configurações / Básico / Eventos personalizados',
      queryParams: {
        tab: 'basic',
      },
      featureFlag: 'custom_events',
    },
    {
      route: 'configurations',
      featureName: 'Configurações avançadas',
      breadcrumb: 'Configurações / Avançado / Configurações avançadas',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Limites de treinamento',
      breadcrumb: 'Configurações / Coaching / Limites de Coaching',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Configuração de treinamento',
      breadcrumb: 'Configurações / Coaching / Configuração do Coaching',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Marcação',
      breadcrumb: 'Configurações / Marcação',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: 'Atributos',
      breadcrumb: 'Configurações / Marcação / Atributos',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Adicionar atributos',
      breadcrumb: 'Configurações / Marcação / Adicionar atributo',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Etiquetas',
      breadcrumb: 'Configurações / Marcação / Etiquetas',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Adicionar etiquetas',
      breadcrumb: 'Configurações / Marcação / Adicionar tags',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Entidades',
      breadcrumb: 'Configurações / Marcação / Entidades',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Eventos desafiadores',
      breadcrumb: 'Desafios / Eventos desafiadores',
      featureFlag: 'challenges_page',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Painel de treinamento',
      breadcrumb: 'Treinamento / Painel de Treinamento',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Motoristas treináveis',
      breadcrumb: 'Condutores treinados / treináveis',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Sessões de treinamento concluídas',
      breadcrumb: 'Treinamento / Sessões de treinamento concluídas',
      featureFlag: 'coaching_workflow',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Eventos',
      breadcrumb: 'Eventos de segurança / Exibição de eventos',
    },
    {
      route: 'safety-events',
      featureName: 'Eventos de segurança',
      breadcrumb: 'Eventos de segurança / Visualização de eventos',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Solicitação de vídeo',
      breadcrumb: 'Solicitação de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de solicitações de vídeo',
      breadcrumb: 'Lista de solicitações de vídeot',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de botões de pânico',
      breadcrumb: 'Lista de botões de pânico',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de eventos sob demanda',
      breadcrumb: 'Lista de eventos sob demanda',
    },
    {
      route: 'video-requests',
      featureName: 'Criar solicitações de vídeo',
      breadcrumb: 'Criar solicitações de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Users',
      breadcrumb: 'Users',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management/edit-user',
      featureName: 'Adicionar usuários',
      breadcrumb: 'Usuários / Adicionar usuárior',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Funções',
      breadcrumb: 'Funções',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management/edit-role',
      featureName: 'Funções ADICIONAR',
      breadcrumb: 'Funções / Adicionar função',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],

  'en-GB': [
    // home
    {
      route: 'home',
      featureName: 'Fleet Highlights',
      breadcrumb: 'Home / Fleet Highlights',
    },
    {
      route: 'home',
      featureName: 'Top Drivers',
      breadcrumb: 'Home / Top Drivers',
      featureFlag: 'home:top_drivers',
    },
    {
      route: 'home',
      featureName: 'Require Coaching Drivers',
      breadcrumb: 'Home / Require Coaching Drivers',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: 'Event Summary',
      breadcrumb: 'Home / Event Summary',
    },
    {
      route: 'home',
      featureName: 'Event Trend',
      breadcrumb: 'Home / Event Trend',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Trip List',
      breadcrumb: 'Trips / Overview / Trip List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Active Drivers',
      breadcrumb: 'Trips / Overview / Active Drivers',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Add Driver',
      breadcrumb: 'Drivers / Add Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Highlights',
      breadcrumb: 'Drivers / Overview / Driver Highlights',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Coach Driver',
      breadcrumb: 'Drivers / Overview / Coach Driver',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Driver Assign Tags',
      breadcrumb: 'Drivers / Overview / Assign Tags',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Driver Coaching Panel',
      breadcrumb: 'Drivers / Overview / Coaching Panel',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Driver Panic Button',
      breadcrumb: 'Drivers / Overview / Panic Button',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Event Summary',
      breadcrumb: 'Drivers / Overview / Event Summary',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver Event Trend',
      breadcrumb: 'Drivers / Overview / Event Trend',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Driver List',
      breadcrumb: 'Drivers / Manage Drivers / Driver List',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Provision Driver',
      breadcrumb: 'Drivers / Manage Drivers / Provision Driver',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Coaching Session',
      breadcrumb: 'Drivers / Overview / Coach Driver',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Completed Sessions',
      breadcrumb: 'Drivers / Overview / Completed Sessions',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Live Asset Tracking',
      breadcrumb: 'Live View / Live Asset Tracking',
    },
    {
      route: 'live-view',
      featureName: 'View Live Stream',
      breadcrumb: 'Live View / View Live Stream',
    },
    // report
    {
      route: 'reports',
      featureName: 'Reports',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Fleet Safety Report',
      breadcrumb: 'Reports / Fleet Safety Report',
    },
    {
      route: 'reports',
      featureName: 'Export History',
      breadcrumb: 'Reports / Export history',
      queryParams: {
        tab: 'export-history',
      },
    },

    {
      route: 'reports',
      featureName: 'Privacy Mode Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Video Request List Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Event Count Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Event List Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'High-G Event List Report',
      breadcrumb: 'Reports / All Reports',
    },
    {
      route: 'reports',
      featureName: 'Panic Button List Report',
      breadcrumb: 'Reports / All Reports',
    },

    {
      route: 'reports',
      featureName: 'Coaching Effectiveness Report (Driver)',
      breadcrumb: 'Reports / Coaching Effectiveness Report (Driver)',
      featureFlag: 'reports:coaching_effectiveness_report',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Asset List',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Driver Assignment',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Modify Asset Duty Type',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Format Device SD Card',
      breadcrumb: 'Assets / Overview / Asset List ',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Reboot Device',
      breadcrumb: 'Assets / Overview / Asset List',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'Batch Asset Update',
      breadcrumb: 'Assets / Manage / Batch Updation',
      queryParams: {
        tab: 'manage',
      },
    },
    {
      route: 'assets',
      featureName: 'Devices',
      breadcrumb: 'Assets / Devices / Semi-Provisioned Devices',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Semi-Provisioned Devices',
      breadcrumb: 'Assets / Devices / Semi-Provisioned Devices',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Basic Configurations',
      breadcrumb: 'Configurations / Basic / Basic Configurations',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Custom Events',
      breadcrumb: 'Configurations / Basic / Custom Events',
      queryParams: {
        tab: 'basic',
      },
      featureFlag: 'custom_events',
    },
    {
      route: 'configurations',
      featureName: 'Advanced Configurations',
      breadcrumb: 'Configurations / Advanced / Advanced Configurations',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Coaching Thresholds',
      breadcrumb: 'Configurations / Coaching / Coaching Thresholds',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Coaching Config',
      breadcrumb: 'Configurations / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Tagging',
      breadcrumb: 'Configurations / Tagging',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Attributes',
      breadcrumb: 'Configurations / Tagging / Attributes',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Add Attributes',
      breadcrumb: 'Configurations / Tagging / Add Attribute',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Tags',
      breadcrumb: 'Configurations / Tagging / Tags',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Add Tags',
      breadcrumb: 'Configurations / Tagging / Add Tags',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Entities',
      breadcrumb: 'Configurations / Tagging / Entities',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Challenged Events',
      breadcrumb: 'Challenges / Challenged Events',
      featureFlag: 'challenges_page',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Coaching Panel',
      breadcrumb: 'Coaching / Coaching Panel',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Coachable Drivers',
      breadcrumb: 'Coaching / Coachable Drivers',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Completed Coaching Sessions',
      breadcrumb: 'Coaching / Completed Coaching Sessions',
      featureFlag: 'coaching_workflow',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Events',
      breadcrumb: 'Safety Events / Events View',
    },
    {
      route: 'safety-events',
      featureName: 'Safety Events',
      breadcrumb: 'Safety Events / Events View',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Video Request',
      breadcrumb: 'Video Request',
    },
    {
      route: 'video-requests',
      featureName: 'Video Requests List',
      breadcrumb: 'Video Requests List',
    },
    {
      route: 'video-requests',
      featureName: 'Panic Button List',
      breadcrumb: 'Panic Button List',
    },
    {
      route: 'video-requests',
      featureName: 'Event On-Demand List',
      breadcrumb: 'Event On-Demand List',
    },
    {
      route: 'video-requests',
      featureName: 'Create Video Requests',
      breadcrumb: 'Create Video Request',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Users',
      breadcrumb: 'Users',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management/edit-user',
      featureName: 'Add Users',
      breadcrumb: 'Users / Add User',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Roles',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management/edit-role',
      featureName: 'ADD Roles',
      breadcrumb: 'Roles / Add Role',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],
  'fr-CA': [
    // home
    {
      route: 'home',
      featureName: 'Faits saillants de la flotte',
      breadcrumb: 'Accueil / Faits saillants de la flotte',
    },
    {
      route: 'home',
      featureName: 'Meilleurs chauffeurss',
      breadcrumb: 'Accueil / Meilleurs pilotes',
      featureFlag: 'home:top_drivers',
    },
    {
      route: 'home',
      featureName: 'Exiger des chauffeurs entraîneurs',
      breadcrumb: 'Accueil / Exiger des chauffeurs entraîneurs',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: 'Résumé des Événements',
      breadcrumb: "Accueil / Résumé de l'Événement",
    },
    {
      route: 'home',
      featureName: 'Tendance des Événements',
      breadcrumb: 'Accueil / Tendance des Événements',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Liste de voyage',
      breadcrumb: 'Trajets / Aperçu / Liste des trajets',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Conducteurs actifs',
      breadcrumb: 'Trajets / Aperçu / Conducteurs actifs',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Ajouter un pilote',
      breadcrumb: 'Pilotes / Ajouter un pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Faits saillants du chauffeur',
      breadcrumb: 'Pilotes / Aperçu / Faits saillants des pilotes',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Panneau d'encadrement des conducteurs",
      breadcrumb: 'Pilotes / Aperçu / Panel de coaching',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Bouton panique du conducteur',
      breadcrumb: 'Pilotes / Aperçu / Bouton panique',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: "Résumé de l'événement du conducteur",
      breadcrumb: "Pilotes / Présentation / Résumé de l'événement",
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendance des événements de conduite',
      breadcrumb: 'Pilotes / Aperçu / Tendance des événements',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Liste des pilotes',
      breadcrumb: 'Pilotes / Gérer les pilotes / Liste des pilotes',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Provisionner le pilote',
      breadcrumb: 'Pilotes / Gérer les pilotes / Provisionner le pilote',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Session de coaching',
      breadcrumb: "'Chauffeurs / Aperçu / Chauffeur d'autocar'",
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Sessions terminées',
      breadcrumb: 'Chauffeurs / Aperçu / Sessions terminées',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: "Chauffeur d'autocar",
      breadcrumb: "Chauffeurs / Aperçu / Chauffeur d'autocar",
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: "Tags sur l'attribution des conducteurs",
      breadcrumb: 'Pilotes / Aperçu / Attribuer des étiquettes',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Suivi des actifs en direct',
      breadcrumb: 'Live View / Live Asset Tracking',
    },
    {
      route: 'live-view',
      featureName: 'Voir la diffusion en direct',
      breadcrumb: 'Affichage en direct/suivi des actifs en direct',
    },
    // report
    {
      route: 'reports',
      featureName: 'Rapports',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Rapport sur la sécurité de la flotte',
      breadcrumb: 'Rapports / Rapport sur la sécurité de la flotte',
    },
    {
      route: 'reports',
      featureName: 'Historique des exportations',
      breadcrumb: 'Rapports / Historique des exportations',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'Rapport du mode confidentialité',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport de demande de vidéo',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport du nombre d’événements',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport de la liste des événements',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport des événements à forte accélération',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport de la liste des boutons de panique',
      breadcrumb: 'Rapports / Tous les rapports',
    },
    {
      route: 'reports',
      featureName: 'Rapport sur l’efficacité du coaching (pilote)',
      breadcrumb: 'Rapports / Rapport sur l’efficacité du coaching (pilote)',
      featureFlag: 'reports:coaching_effectiveness_report',
    },
    // assets
    {
      route: 'assets',
      featureName: 'Liste des actifs',
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: 'Affectation du conducteur',
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Modifier le type de droit de l'actif",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Formater la carte SD de l'appareil",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: "Redémarrer l'appareil",
      breadcrumb: 'Actifs / Liste des actifs',
    },
    {
      route: 'assets',
      featureName: 'Dispositifs',
      breadcrumb: 'Actifs / Appareils / Appareils semi-provisionnés',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Appareils semi-provisionnés',
      breadcrumb: 'Actifs / Appareils / Appareils semi-provisionnés',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configurations de base',
      breadcrumb: 'Configurations / De base / Configurations de base',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Événements personnalisés',
      breadcrumb: 'Configurations / De base / Événements personnalisés',
      queryParams: {
        tab: 'basic',
      },
      featureFlag: 'custom_events',
    },
    {
      route: 'configurations',
      featureName: 'Configurations avancées',
      breadcrumb: 'Configurations / Avancées / Configurations avancées',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Seuils d entraînement',
      breadcrumb: 'Configurations / Coaching / Seuils d entraînement',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Coaching Config',
      breadcrumb: 'Configurations / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Balisage',
      breadcrumb: 'Configurations / balisage',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Attributs',
      breadcrumb: 'Configurations / balisage / attributs',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Ajouter des attributs',
      breadcrumb: 'Configurations / Balisage / Ajouter un attribut',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Balises',
      breadcrumb: 'Configurations / Balisage / Balises',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Ajouter des tags',
      breadcrumb: 'Configurations / Balisage / Ajouter des balises',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Entités',
      breadcrumb: 'Configurations / Balisage / Entités',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Événements contestés',
      breadcrumb: 'Défis / Événements contestés',
      featureFlag: 'challenges_page',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: "Panneau d'encadrement",
      breadcrumb: "Entraînement / Panel d'entraîneursl",
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Conducteurs entraînables',
      breadcrumb: 'Coaching / Conducteurs à coacher',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Sessions de coaching terminées',
      breadcrumb: 'Coaching / Sessions de coaching terminées',
      featureFlag: 'coaching_workflow',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Événements',
      breadcrumb: 'Événements de sécurité / Vue des Événements',
    },
    {
      route: 'safety-events',
      featureName: 'Événements liés à la sécurité',
      breadcrumb: "Événements de sécurité / Vue d'ensemble des événements",
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Demandes de vidéo',
      breadcrumb: 'Demandes de vidéo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de pedidos de vídeo',
      breadcrumb: 'Lista de pedidos de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des boutons de panique',
      breadcrumb: 'Panic Button List',
    },
    {
      route: 'video-requests',
      featureName: 'Liste des événements à la demande',
      breadcrumb: 'Liste des événements à la demande',
    },
    {
      route: 'video-requests',
      featureName: 'Criar pedido de vídeo',
      breadcrumb: 'Criar pedido de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'Utilisateurs',
      breadcrumb: 'Utilisateurs',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Ajouter un utilisateur',
      breadcrumb: 'Utilisateurs',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Rôles',
      breadcrumb: 'Rôles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management',
      featureName: 'AJOUTER RÔLE ',
      breadcrumb: 'Rôles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],
  'es-419': [
    // home
    {
      route: 'home',
      featureName: 'Aspectos destacados de la flota',
      breadcrumb: 'Inicio / Lo más destacado de la flota',
    },
    {
      route: 'home',
      featureName: 'Conductores mejores',
      breadcrumb: 'Inicio / Principales conductores',
      featureFlag: 'home:top_drivers',
    },
    {
      route: 'home',
      featureName: 'Requiere entrenadoras',
      breadcrumb: 'Inicio / Requiere entrenadoras',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: 'Resumen de eventos',
      breadcrumb: 'Inicio / Resumen del eventos',
    },
    {
      route: 'home',
      featureName: 'Tendencia de eventoss',
      breadcrumb: 'Inicio / Tendencia de eventoss',
    },
    // trips
    {
      route: 'trips',
      featureName: 'Lista de viajes',
      breadcrumb: 'Viajes / Descripción general / Lista de viajes',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'Conductores activos',
      breadcrumb: 'Viajes / Descripción general / Conductores activos',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'Agregar conductor',
      breadcrumb: 'Controladores / Agregar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Aspectos destacados del conductor',
      breadcrumb: 'Controladores / Descripción general / Aspectos destacados del controlador',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Panel de entrenamiento de conductores',
      breadcrumb: 'Controladores / Descripción general / Panel de entrenamiento',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Botón de pánico del conductor',
      breadcrumb: 'Controladores / Descripción general / Botón de pánico',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Resumen del evento del conductor',
      breadcrumb: 'Controladores / Descripción general / Resumen de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Tendencia de eventos del conductor',
      breadcrumb: 'Impulsores / Descripción general / Tendencia de eventos',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'Lista de conductores',
      breadcrumb: 'Controladores / Administrar controladores / Lista de controladores',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Conductora de provisión',
      breadcrumb: 'Controladores / Administrar controladores / Aprovisionar controlador',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'Sesión de coaching',
      breadcrumb: 'Conductores / Visión general / Conductor de autocar',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Sesiones finalizadas',
      breadcrumb: 'Conductores / Visión general / Sesiones finalizadas',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },

    {
      route: 'drivers',
      featureName: 'Conductor de autocar',
      breadcrumb: 'Conductores / Visión general / Conductor de autocar',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: 'Etiquetas de asignación de conductores',
      breadcrumb: 'Controladores / Visión general / Asignar etiquetas',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    // live view
    {
      route: 'live-view',
      featureName: 'Seguimiento de activos en vivo',
      breadcrumb: 'Vista en vivo / Seguimiento de activos en vivo',
    },
    {
      route: 'live-view',
      featureName: 'Ver transmisión en vivo',
      breadcrumb: 'Vista en vivo / Ver transmisión en vivo',
    },
    // report
    {
      route: 'reports',
      featureName: 'Informes',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports/fleet-safety',
      featureName: 'Informe de seguridad de la flota',
      breadcrumb: 'Informes / Informe de seguridad de la flota',
    },

    {
      route: 'reports',
      featureName: 'Informe de modo de privacidad',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de solicitud de video',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de conteo de eventos',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de lista de eventos',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de eventos con alta fuerza G',
      breadcrumb: 'Informes / Todos los informes',
    },
    {
      route: 'reports',
      featureName: 'Informe de lista de botones de pánico',
      breadcrumb: 'Informes / Todos los informes',
    },

    {
      route: 'reports',
      featureName: 'Informes archivados',
      breadcrumb: 'Informes / Informes archivados',
      queryParams: {
        tab: 'archive',
      },
    },
    // assets
    {
      route: 'assets',
      featureName: 'Lista de activos',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Asignación de conductor',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Modificar tipo de derecho de activo',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Formatear la tarjeta SD del dispositivo',
      breadcrumb: 'Activos / Lista de activos ',
    },
    {
      route: 'assets',
      featureName: 'Reiniciar dispositivo',
      breadcrumb: 'Activos / Lista de activos',
    },
    {
      route: 'assets',
      featureName: 'Dispositivos',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'Dispositivos semiprovisionados',
      breadcrumb: 'Activos / Dispositivos / Dispositivos semiprovisionados',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: 'Configuraciones básicas',
      breadcrumb: 'Configuraciones / Básica / Configuraciones Básicas',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'Eventos personalizados',
      breadcrumb: 'Configuraciones / Básica / Eventos personalizados',
      queryParams: {
        tab: 'basic',
      },
      featureFlag: 'custom_events',
    },
    {
      route: 'configurations',
      featureName: 'Configuraciones avanzadas',
      breadcrumb: 'Configuraciones / Avanzadas / Configuraciones Avanzadas',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'Umbrales de entrenamiento',
      breadcrumb: 'Configuraciones / Coaching / Umbrales de entrenamiento',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Configuración de Coaching',
      breadcrumb: 'Configuraciones / Coaching / Coaching Config',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Etiquetado',
      breadcrumb: 'Configuraciones / Etiquetado',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Atributos',
      breadcrumb: 'Configuraciones / Etiquetado / Atributos',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: 'Añadir atributos',
      breadcrumb: 'Configuraciones / Etiquetado / Añadir atributo',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Etiquetas',
      breadcrumb: 'Configuraciones / Etiquetado / Etiquetas',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: 'Añadir etiquetas',
      breadcrumb: 'Configuraciones / Etiquetado / Añadir etiquetas',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: 'Entidades',
      breadcrumb: 'Configuraciones / Etiquetado / Entidades',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'Eventos cuestionados',
      breadcrumb: 'Cuestionados / Eventos cuestionados',
      featureFlag: 'challenges_page',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'Panel de entrenamiento',
      breadcrumb: 'Panel de Entrenamiento / Coaching',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Conductores entrenables',
      breadcrumb: 'Coaching / Conductores entrenables',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: 'Sesiones de coaching completadas',
      breadcrumb: 'Coaching / Sesiones de coaching completadas',
      featureFlag: 'coaching_workflow',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'Eventos',
      breadcrumb: 'Eventos de seguridad / Vista de eventos',
    },
    {
      route: 'safety-events',
      featureName: 'Eventos de seguridad',
      breadcrumb: 'Eventos de seguridad / Vista de eventos',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'Solicitudes de vídeo',
      breadcrumb: 'Solicitudes de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de solicitudes de vídeo',
      breadcrumb: 'Lista de solicitudes de vídeo',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de botones de pánico',
      breadcrumb: 'Lista de botones de pánico',
    },
    {
      route: 'video-requests',
      featureName: 'Lista de eventos a la carta',
      breadcrumb: 'Lista de eventos a la carta',
    },
    {
      route: 'video-requests',
      featureName: 'Crear solicitud de vídeo',
      breadcrumb: 'Crear solicitud de vídeo',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'USUARIOS',
      breadcrumb: 'USUARIOS',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'AÑADIR USUARIO',
      breadcrumb: 'USUARIOS',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: 'Roles',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management',
      featureName: 'AÑADIR ROL',
      breadcrumb: 'Roles',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],
  ja: [
    // home
    {
      route: 'home',
      featureName: 'フリートハイライト',
      breadcrumb: 'ホーム / フリートハイライト',
    },
    {
      route: 'home',
      featureName: 'トップドライバー',
      breadcrumb: 'ホーム / トップドライバー',
    },
    {
      route: 'home',
      featureName: 'コーチング・ドライバーを求める',
      breadcrumb: 'ホーム / コーチング・ドライバーを求める',
    },
    {
      route: 'home',
      featureName: 'イベント概要',
      breadcrumb: 'ホーム / イベント概要',
    },
    {
      route: 'home',
      featureName: 'イベント動向',
      breadcrumb: 'ホーム / イベント・トレンド',
    },
    // trips
    {
      route: 'trips',
      featureName: 'トリップリスト',
      breadcrumb: 'トリップ / 概要 / トリップリスト',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: 'アクティブドライバー',
      breadcrumb: 'トリップ / 概要 / アクティブドライバー',
      queryParams: {
        tab: 'active-drivers',
      },
    },
    // drivers
    {
      route: 'drivers',
      featureName: 'ドライバーの追加',
      breadcrumb: 'ドライバー / ドライバーの追加',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'ドライバーハイライト',
      breadcrumb: 'ドライバー / 概要 / ドライバー・ハイライト',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'コーチ・ドライブ',
      breadcrumb: 'ドライバー / 概要 / コーチドライバー',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'ドライバー割り当てタグ',
      breadcrumb: 'ドライバー / 概要 / タグの割り当て',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'ドライバー・コーチング・パネル',
      breadcrumb: 'ドライバー / 概要 / コーチング・パネル',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'ドライバー・パニック・ボタン',
      breadcrumb: 'ドライバー / 概要 / パニックボタン',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'ドライバー・イベント概要',
      breadcrumb: 'ドライバー / 概要 / イベント概要',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'ドライバーイベント傾向',
      breadcrumb: 'ドライバー / 概要 / イベント傾向',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: 'ドライバーリスト',
      breadcrumb: 'ドライバー / ドライバー管理 / ドライバーリスト',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'プロビジョンドライバー',
      breadcrumb: 'ドライバ / ドライバの管理 / ドライバの提供',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: 'コーチング・セッション',
      breadcrumb: 'ドライバー / 概要 / コーチドライバー',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: '終了したセッション',
      breadcrumb: 'ドライバー / 概要 / 終了したセッション',
      queryParams: {
        tab: 'overview',
      },
    },
    // live view
    {
      route: 'live-view',
      featureName: 'ライブ・アセット・トラッキング',
      breadcrumb: 'ライブビュー / ライブアセットトラッキング',
    },
    {
      route: 'live-view',
      featureName: 'ライブストリームを見る',
      breadcrumb: 'ライブビュー/ライブストリームを見る',
    },
    // report
    {
      route: 'reports',
      featureName: 'レポート',
      breadcrumb: 'レポート / すべてのレポート',
    },
    {
      route: 'reports/fleet-safety',
      featureName: '車両安全レポート',
      breadcrumb: 'レポート / 車両安全レポート',
    },
    {
      route: 'reports',
      featureName: '輸出履歴',
      breadcrumb: 'レポート / エクスポート履歴',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: 'コーチング効果レポート（ドライバー）',
      breadcrumb: 'レポート / コーチング効果レポート（ドライバー）',
    },
    // assets
    {
      route: 'assets',
      featureName: '資産リスト',
      breadcrumb: '資産 / 概要 / 資産リスト',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'ドライバー割り当て',
      breadcrumb: '資産 / 概要 / 資産リスト',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: '資産デューティタイプの変更',
      breadcrumb: '資産 / 概要 / 資産リスト',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'SDカードのフォーマット',
      breadcrumb: '資産 / 概要 / 資産リスト',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: 'デバイスの再起動',
      breadcrumb: '資産 / 概要 / 資産リスト',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: '一括資産更新',
      breadcrumb: '資産 / 管理 / バッチ更新',
      queryParams: {
        tab: 'manage',
      },
    },
    {
      route: 'assets',
      featureName: 'デバイス',
      breadcrumb: '資産 / デバイス / 準プロビジョニング・デバイス',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: 'セミプロビジョン・デバイス',
      breadcrumb: '資産 / デバイス / 準プロビジョニング・デバイス',
      queryParams: {
        tab: 'devices',
      },
    },
    // configurations
    {
      route: 'configurations',
      featureName: '基本構成',
      breadcrumb: 'コンフィギュレーション / 基本 / 基本コンフィギュレーション',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: 'カスタムイベント',
      breadcrumb: '設定 / 基本 / カスタム・イベント',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: '高度な設定',
      breadcrumb: '設定 / 詳細設定 / 詳細設定',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: 'コーチングのしきい値',
      breadcrumb: 'コンフィギュレーション / コーチング / コーチングのしきい値',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'コーチング構成',
      breadcrumb: 'コンフィギュレーション / コーチング / コーチング・コンフィギュレーション',
      queryParams: {
        tab: 'coaching',
      },
    },
    {
      route: 'configurations',
      featureName: 'タグ付け',
      breadcrumb: 'コンフィギュレーション／タグ付け',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations',
      featureName: '属性',
      breadcrumb: 'コンフィギュレーション / タグ / 属性',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-attribute',
      featureName: '属性の追加',
      breadcrumb: '設定 / タグ / 属性の追加',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
    },
    {
      route: 'configurations',
      featureName: 'タグ',
      breadcrumb: 'コンフィギュレーション / タグ / タグ',
      queryParams: {
        tab: 'tagging',
      },
    },
    {
      route: 'configurations/add-tags',
      featureName: 'タグを追加',
      breadcrumb: '設定 / タグ / タグの追加',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'configurations',
      featureName: 'エンティティ',
      breadcrumb: 'コンフィギュレーション / タグ / エンティティ',
      queryParams: {
        tab: 'tagging',
      },
    },
    //Challenges
    {
      route: 'challenges',
      featureName: 'チャレンジド・イベント',
      breadcrumb: 'チャレンジ / チャレンジド・イベント',
    },
    //Coaching
    {
      route: 'coaching',
      featureName: 'コーチング・パネル',
      breadcrumb: 'コーチング / コーチング・パネル',
    },
    {
      route: 'coaching',
      featureName: 'コーチング可能なドライバー',
      breadcrumb: 'コーチング／コーチング可能なドライバー',
    },
    {
      route: 'coaching',
      featureName: '終了したコーチング・セッション',
      breadcrumb: 'コーチング / 終了したコーチング・セッション',
    },
    //Events View
    {
      route: 'safety-events',
      featureName: 'イベント',
      breadcrumb: '安全イベント / イベントビュー',
    },
    {
      route: 'safety-events',
      featureName: '安全イベント',
      breadcrumb: '安全イベント / イベント・ヴィ',
    },
    //Video Request
    {
      route: 'video-requests',
      featureName: 'ビデオ・リクエスト',
      breadcrumb: 'ビデオ・リクエスト',
    },
    {
      route: 'video-requests',
      featureName: 'ビデオリクエストリスト',
      breadcrumb: 'ビデオリクエストリスト',
    },
    {
      route: 'video-requests',
      featureName: 'パニック・ボタン一覧',
      breadcrumb: 'パニック・ボタン一覧',
    },
    {
      route: 'video-requests',
      featureName: 'イベント・オンデマンド・リスト',
      breadcrumb: 'イベント・オンデマンド・リスト',
    },
    {
      route: 'video-requests',
      featureName: 'ビデオ・リクエストの作成',
      breadcrumb: 'ビデオ・リクエストの作成',
    },
    // Users Management
    {
      route: 'user-management',
      featureName: 'ユーザー',
      breadcrumb: 'ユーザー',
      queryParams: {
        tab: 'users',
      },
    },
    {
      route: 'user-management/edit-user',
      featureName: 'ユーザーの追加',
      breadcrumb: 'ユーザー / ユーザーの追加',
      queryParams: {
        action: 'add',
      },
    },
    {
      route: 'user-management',
      featureName: '役割',
      breadcrumb: '役割',
      queryParams: {
        tab: 'roles',
      },
    },
    {
      route: 'user-management/edit-role',
      featureName: '役割の追加',
      breadcrumb: '役割 / 役割の追加',
      queryParams: {
        action: 'add',
      },
    },
  ],
  ko: [
    // home
    {
      route: 'home',
      featureName: '차량 하이라이트',
      breadcrumb: '홈 / 차량 하이라이트',
    },
    {
      route: 'home',
      featureName: '우수 운전자',
      breadcrumb: '홈 / 우수 운전자',
      featureFlag: 'home:top_drivers',
    },
    {
      route: 'home',
      featureName: '코칭이 필요한 운전자',
      breadcrumb: '홈 / 코칭이 필요한 운전자',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'home',
      featureName: '이벤트 요약',
      breadcrumb: '홈 / 이벤트 요약',
    },
    {
      route: 'home',
      featureName: '이벤트 추세',
      breadcrumb: '홈 / 이벤트 추세',
    },

    // trips
    {
      route: 'trips',
      featureName: '주행 목록',
      breadcrumb: '주행 / 개요 / 주행 목록',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'trips',
      featureName: '활동 중인 운전자',
      breadcrumb: '주행 / 개요 / 활동 중인 운전자',
      queryParams: {
        tab: 'active-drivers',
      },
    },

    // drivers
    {
      route: 'drivers',
      featureName: '운전자 추가',
      breadcrumb: '운전자 / 운전자 추가',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: '운전자 하이라이트',
      breadcrumb: '운전자 / 개요 / 운전자 하이라이트',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: '운전자 코칭',
      breadcrumb: '운전자 / 개요 / 운전자 코칭',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: '운전자 태그 지정',
      breadcrumb: '운전자 / 개요 / 태그 지정',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'drivers',
      featureName: '코칭 패널',
      breadcrumb: '운전자 / 개요 / 코칭 패널',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: '운전자 비상 버튼',
      breadcrumb: '운전자 / 개요 / 비상 버튼',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: '운전자 이벤트 요약',
      breadcrumb: '운전자 / 개요 / 이벤트 요약',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: '운전자 이벤트 추세',
      breadcrumb: '운전자 / 개요 / 이벤트 추세',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'drivers',
      featureName: '운전자 목록',
      breadcrumb: '운전자 / 운전자 관리 / 운전자 목록',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: '운전자 등록',
      breadcrumb: '운전자 / 운전자 관리 / 운전자 등록',
      queryParams: {
        tab: 'manage-drivers',
      },
    },
    {
      route: 'drivers',
      featureName: '코칭 세션',
      breadcrumb: '운전자 / 개요 / 코칭 세션',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'drivers',
      featureName: '완료된 세션',
      breadcrumb: '운전자 / 개요 / 완료된 세션',
      queryParams: {
        tab: 'overview',
      },
      featureFlag: 'coaching_workflow',
    },

    // live view
    {
      route: 'live-view',
      featureName: '실시간 자산 추적',
      breadcrumb: '라이브 보기 / 실시간 자산 추적',
    },
    {
      route: 'live-view',
      featureName: '실시간 스트림 보기',
      breadcrumb: '라이브 보기 / 실시간 스트림 보기',
    },

    // report
    {
      route: 'reports',
      featureName: '보고서',
      breadcrumb: '보고서 / 전체 보고서',
    },
    {
      route: 'reports/fleet-safety',
      featureName: '차량 안전 보고서',
      breadcrumb: '보고서 / 차량 안전 보고서',
    },
    {
      route: 'reports',
      featureName: '내보내기 기록',
      breadcrumb: '보고서 / 내보내기 기록',
      queryParams: {
        tab: 'export-history',
      },
    },
    {
      route: 'reports',
      featureName: '개인정보 보호 모드 보고서',
      breadcrumb: '보고서 / 전체 보고서',
    },
    {
      route: 'reports',
      featureName: '비디오 요청 목록 보고서',
      breadcrumb: '보고서 / 전체 보고서',
    },
    {
      route: 'reports',
      featureName: '이벤트 수 보고서',
      breadcrumb: '보고서 / 전체 보고서',
    },
    {
      route: 'reports',
      featureName: '이벤트 목록 보고서',
      breadcrumb: '보고서 / 전체 보고서',
    },
    {
      route: 'reports',
      featureName: '고중력 이벤트 목록 보고서',
      breadcrumb: '보고서 / 전체 보고서',
    },
    {
      route: 'reports',
      featureName: '비상 버튼 보고서',
      breadcrumb: '보고서 / 전체 보고서',
    },
    {
      route: 'reports',
      featureName: '코칭 효과 보고서 (운전자)',
      breadcrumb: '보고서 / 코칭 효과 보고서 (운전자)',
      featureFlag: 'reports:coaching_effectiveness_report',
    },

    // assets
    {
      route: 'assets',
      featureName: '자산 목록',
      breadcrumb: '자산 / 개요 / 자산 목록',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: '운전자 할당',
      breadcrumb: '자산 / 개요 / 자산 목록',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: '자산 근무 유형 수정',
      breadcrumb: '자산 / 개요 / 자산 목록',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: '장치 SD 카드 포맷',
      breadcrumb: '자산 / 개요 / 자산 목록',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: '장치 재부팅',
      breadcrumb: '자산 / 개요 / 자산 목록',
      queryParams: {
        tab: 'overview',
      },
    },
    {
      route: 'assets',
      featureName: '대량 자산 업데이트',
      breadcrumb: '자산 / 관리 / 대량 업데이트',
      queryParams: {
        tab: 'manage',
      },
    },
    {
      route: 'assets',
      featureName: '장치',
      breadcrumb: '자산 / 장치 / 반프로비저닝 장치',
      queryParams: {
        tab: 'devices',
      },
    },
    {
      route: 'assets',
      featureName: '반프로비저닝 장치',
      breadcrumb: '자산 / 장치 / 반프로비저닝 장치',
      queryParams: {
        tab: 'devices',
      },
    },

    // configurations
    {
      route: 'configurations',
      featureName: '기본 설정',
      breadcrumb: '설정 / 기본 / 기본 설정',
      queryParams: {
        tab: 'basic',
      },
    },
    {
      route: 'configurations',
      featureName: '사용자 지정 이벤트',
      breadcrumb: '설정 / 기본 / 사용자 지정 이벤트',
      queryParams: {
        tab: 'basic',
      },
      featureFlag: 'custom_events',
    },
    {
      route: 'configurations',
      featureName: '고급 설정',
      breadcrumb: '설정 / 고급 / 고급 설정',
      queryParams: {
        tab: 'advanced',
      },
    },
    {
      route: 'configurations',
      featureName: '코칭 임계값',
      breadcrumb: '설정 / 코칭 / 코칭 임계값',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: '코칭 구성',
      breadcrumb: '설정 / 코칭 / 코칭 구성',
      queryParams: {
        tab: 'coaching',
      },
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'configurations',
      featureName: '태깅',
      breadcrumb: '설정 / 태깅',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: '속성',
      breadcrumb: '설정 / 태깅 / 속성',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-attribute',
      featureName: '속성 추가',
      breadcrumb: '설정 / 태깅 / 속성 추가',
      queryParams: {
        action: 'add',
        attributeId: '',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: '태그',
      breadcrumb: '설정 / 태깅 / 태그',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations/add-tags',
      featureName: '태그 추가',
      breadcrumb: '설정 / 태깅 / 태그 추가',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'tagging_workflow',
    },
    {
      route: 'configurations',
      featureName: '엔터티',
      breadcrumb: '설정 / 태깅 / 엔터티',
      queryParams: {
        tab: 'tagging',
      },
      featureFlag: 'tagging_workflow',
    },

    // challenges
    {
      route: 'challenges',
      featureName: '이의 제기된 이벤트',
      breadcrumb: '이의 제기 / 이의 제기된 이벤트',
      featureFlag: 'challenges_page',
    },

    // coaching
    {
      route: 'coaching',
      featureName: '코칭 패널',
      breadcrumb: '코칭 / 코칭 패널',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: '코칭 대상 운전자',
      breadcrumb: '코칭 / 코칭 대상 운전자',
      featureFlag: 'coaching_workflow',
    },
    {
      route: 'coaching',
      featureName: '완료된 코칭 세션',
      breadcrumb: '코칭 / 완료된 코칭 세션',
      featureFlag: 'coaching_workflow',
    },

    // events view
    {
      route: 'safety-events',
      featureName: '이벤트',
      breadcrumb: '안전 이벤트 / 이벤트 보기',
    },
    {
      route: 'safety-events',
      featureName: '안전 이벤트',
      breadcrumb: '안전 이벤트 / 이벤트 보기',
    },

    // video requests
    {
      route: 'video-requests',
      featureName: '비디오 요청',
      breadcrumb: '비디오 요청',
    },
    {
      route: 'video-requests',
      featureName: '비디오 요청 목록',
      breadcrumb: '비디오 요청 목록',
    },
    {
      route: 'video-requests',
      featureName: '비상 버튼 목록',
      breadcrumb: '비상 버튼 목록',
    },
    {
      route: 'video-requests',
      featureName: '온디맨드 이벤트 목록',
      breadcrumb: '온디맨드 이벤트 목록',
    },
    {
      route: 'video-requests',
      featureName: '비디오 요청 생성',
      breadcrumb: '비디오 요청 생성',
    },

    // user management
    {
      route: 'user-management',
      featureName: '사용자',
      breadcrumb: '사용자',
      queryParams: {
        tab: 'users',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management/edit-user',
      featureName: '사용자 추가',
      breadcrumb: '사용자 / 사용자 추가',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'user_management_page',
    },
    {
      route: 'user-management',
      featureName: '역할',
      breadcrumb: '역할',
      queryParams: {
        tab: 'roles',
      },
      featureFlag: 'access_control:user_roles',
    },
    {
      route: 'user-management/edit-role',
      featureName: '역할 추가',
      breadcrumb: '역할 / 역할 추가',
      queryParams: {
        action: 'add',
      },
      featureFlag: 'access_control:user_roles',
    },
  ],
};
